import { isProduction, deploymentTier } from '../../data/constants.ts';
import { AsApp } from '../as-app/index.ts';
import { liveAppData } from '../../store/store.ts';
import { useShadow, useShadowStyle } from '../wcUtil.ts';
import styleText from './as-footer.css?raw';

const ALWAYS_DETAILED = true

class AsVersionTag extends HTMLElement{
  versions:{[key:string]:string|undefined}={
    app:undefined ,
    components:undefined,
    trcad:undefined,
    trcadScript:undefined
  }
  removeEnvEffect:(()=>void)|undefined
  async getVersions(){
    const appEl = document.querySelector("as-app") as AsApp | null;
    const result = await appEl?.getVersions?.();
    this.versions.app = result?.app;
    this.versions.components = result?.components;
    this.versions.trcad = result?.trCad;
    this.versions.trcadScript = result?.trCadScript;
  }

  get html(){
    const detailedVersions = `| ASC v${this.versions.components ?? '?.?.?'}
        | script v${this.versions.trcadScript ?? '?.?.?'}
        | trCAD v${this.versions.trcad ?? '?.?.?'}`
    return /*html*/`
      <span id="version-tags">
        app v${this.versions.app ?? '?.?.?'}${liveAppData.appEnv === 'grabcad' ? ' GC' : ''} ${isProduction?'':`(${deploymentTier})`}
        ${ ALWAYS_DETAILED 
          ? detailedVersions
          : `${ isProduction
            ? ''
            : detailedVersions  }`
        }
        
      </span>
  `
  }
  redraw(){
    if(this.shadowRoot){
      this.shadowRoot.innerHTML = this.html
    }
  }
  async connectedCallback(){
    useShadow(this)
    await useShadowStyle(this, styleText, './as-footer.css')
    // The integration env can resolve after first paint — e.g. GrabCAD env is
    // detected asynchronously once userData loads (grabcad-mixin._initGrabCADEnv),
    // which sets liveAppData.appEnv. Re-render so the GC marker stays in sync.
    this.removeEnvEffect = liveAppData.addSideEffect('appEnv', () => this.redraw())
    await this.getVersions()
    this.redraw()
  }
  disconnectedCallback(){
    this.removeEnvEffect?.()
    this.removeEnvEffect = undefined
  }
}

export class AsFooter extends HTMLElement{

  get html(){
    return /*html*/`
      <as-version-tag></as-version-tag>
      <as-trinckle-label></as-trinckle-label>
  `
  }
  async connectedCallback(){
    useShadow(this)
    await useShadowStyle(this, styleText, './as-footer.css')
  }
}

customElements.define('as-version-tag', AsVersionTag)
customElements.define('as-footer', AsFooter)